// import axios from "axios";
// import { Spinner } from "@blueprintjs/core";
// import { useEffect, useState } from "react";
// import { fabric } from "fabric";
// import { APIURL } from "../../config";
// import { findObject, getUniqueValues } from "../../utils/helper";
// import "./preview.css";

// export function PreviewScreen({ canvases, templateID }) {
//     const [images, setImages] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [labelConfig, setLabelConfig] = useState({
//         sheetWidth: 8.5,
//         sheetHeight: 11,
//         rows: 11,
//         cols: 5,
//         // labelWidth: 760,
//         // labelHeight: 700,
//         gapX: 30,
//         gapY: 30,
//         marginLeft: 0,
//         marginTop: 0,
//         totalQty: 1
//     });
//     const [configLoaded, setConfigLoaded] = useState(false);
//     const [downloadingPDF, setDownloadingPDF] = useState(false);

//     const calculateAndSetConfig = (templateData, categoryObj) => {
//         if (!templateData.sheetWidth && !templateData.sheetHeight && !templateData.rows && !templateData.cols && !templateData.gapX && !templateData.gapY) {
//             templateData.sheetWidth = labelConfig.sheetWidth
//             templateData.sheetHeight = labelConfig.sheetHeight
//             templateData.rows = labelConfig.rows;
//             templateData.cols = labelConfig.cols;
//             templateData.gapX = labelConfig.gapX;
//             templateData.gapY = labelConfig.gapY;
//             templateData.marginLeft = labelConfig.marginLeft;
//             templateData.marginTop = labelConfig.marginTop;
//         }
//         let sheetWidth = Number(templateData.sheetWidth);
//         let sheetHeight = Number(templateData.sheetHeight);
//         const rows = Number(templateData.rows);
//         const cols = Number(templateData.cols);
//         const gapX = Number(templateData.gapX);
//         const gapY = Number(templateData.gapY);
//         const marginLeft = Number(templateData.marginLeft) * cols;
//         const marginTop = Number(templateData.marginTop) * cols;
//         const totalQty = Number(templateData.totalQty) || 55;

//         const ratio = Math.min(600 / categoryObj.canvas_width_px, 600 / categoryObj.canvas_height_px);

//         // const labelWidth = (categoryObj.canvas_width_px * ratio) + gapX;
//         // const labelHeight = (categoryObj.canvas_height_px * ratio) + gapY;

//         const labelWidth = (categoryObj.canvas_width_px * ratio) + gapX - (gapX / cols);
//         const labelHeight = (categoryObj.canvas_height_px * ratio) + gapY;

//         sheetWidth = (cols * labelWidth) + (marginLeft * cols);
//         sheetHeight = (rows * labelHeight) + (marginTop * cols);

//         const newConfig = {
//             sheetWidth,
//             sheetHeight,
//             rows,
//             cols,
//             labelWidth: (categoryObj.canvas_width_px * ratio) + gapX,
//             labelHeight: (categoryObj.canvas_height_px * ratio) + gapY,
//             gapX,
//             gapY,
//             marginLeft,
//             marginTop,
//             canvasWidth: categoryObj.canvas_width_px,
//             canvasHeight: categoryObj.canvas_height_px,
//             totalQty
//         };

//         setLabelConfig(newConfig);
//         console.log("labelConfig loaded:", newConfig);
//         setConfigLoaded(true);
//     };

//     // Fetch template configuration when templateID is provided
//     useEffect(() => {
//         if (!templateID) return;
//         setConfigLoaded(false);
//         axios.get(`${APIURL}/api/v1/template`, { params: { template_id: templateID } }).then((response) => {
//             if (response.data.data.length > 0) {
//                 const get_category = `${APIURL}/api/v1/category`;
//                 let catSlugValue = response.data.data[0].cat_slug;
//                 axios.post(get_category, { cat_slug: catSlugValue }).then(function (categoryResponse) {
//                     let result = findObject(categoryResponse.data.data, (obj) => obj.template_id === parseInt(templateID, 10));
//                     // calculateAndSetConfig(labelConfig, result);
//                     calculateAndSetConfig(response.data.data[0], result);
//                 }).catch(function (error) {
//                     console.log(error);
//                 });
//             }
//         }).catch((error) => {
//             console.error("Error fetching template:", error);
//         });
//     }, [templateID]);

//     // Fetch default template when no templateID is provided
//     useEffect(() => {
//         if (templateID) return;

//         setConfigLoaded(false);
//         const fetchDefaultTemplate = async () => {
//             try {
//                 const categoriesRes = await axios.get(`${APIURL}/api/v1/categories`);

//                 if (categoriesRes.data.data.length === 0) {
//                     console.log("No categories found");
//                     return;
//                 }

//                 const categoryRes = await axios.post(`${APIURL}/api/v1/category`, {
//                     cat_slug: categoriesRes.data.data[0].cat_slug
//                 });

//                 if (categoryRes.data.data.length === 0) {
//                     console.log("No category detail found");
//                     return;
//                 }

//                 const categoryDetail = categoryRes.data.data[0];

//                 const templateRes = await axios.get(`${APIURL}/api/v1/template`, {
//                     params: { template_id: categoryDetail.template_id }
//                 });

//                 if (templateRes.data.data.length > 0) {
//                     let result = findObject(categoryRes.data.data, (obj) => obj.template_id === parseInt(categoryDetail.template_id, 10));
//                     // calculateAndSetConfig(labelConfig, result);
//                     calculateAndSetConfig(templateRes.data.data[0], result);
//                 }
//             } catch (error) {
//                 console.error("Error fetching default template:", error);
//             }
//         };

//         fetchDefaultTemplate();
//     }, [templateID]);

//     useEffect(() => {
//         if (
//             configLoaded &&
//             canvases?.length &&
//             labelConfig.rows > 0 &&
//             labelConfig.cols > 0 &&
//             labelConfig.labelWidth > 0 &&
//             labelConfig.labelHeight > 0
//         ) {
//             generatePreview();
//         }
//     }, [labelConfig, canvases, configLoaded]);

//     const generatePreview = async () => {
//         setLoading(true);

//         // Validate canvases
//         if (!canvases || canvases.length === 0) {
//             setLoading(false);
//             return;
//         }

//         try {
//             const pageGap = 20;
//             const { rows, cols, labelWidth, labelHeight, gapX, gapY, marginLeft, marginTop, totalQty } = labelConfig;

//             // Calculate how many sheets are needed based on totalQty
//             const labelsPerSheet = rows * cols;
//             const totalSheets = Math.ceil(totalQty / labelsPerSheet);

//             // Calculate total height needed for all pages (canvases) and all sheets
//             const singleSheetHeight = labelConfig.sheetHeight;
//             const totalHeight = (singleSheetHeight * canvases.length * totalSheets) + (pageGap * (canvases.length * totalSheets - 1));

//             // Create one large canvas to hold all pages
//             const combinedCanvas = new fabric.StaticCanvas(null, {
//                 width: labelConfig.sheetWidth,
//                 height: totalHeight,
//                 backgroundColor: "#f5f5f5"
//             });

//             let currentPageIndex = 0;

//             // Generate preview for each sheet
//             for (let sheetIndex = 0; sheetIndex < totalSheets; sheetIndex++) {
//                 // Generate preview for each canvas (Front, Back, etc.) on this sheet
//                 for (let canvasIndex = 0; canvasIndex < canvases.length; canvasIndex++) {
//                     const labelCanvas = canvases[canvasIndex];

//                     if (!labelCanvas) {
//                         console.warn(`Canvas at index ${canvasIndex} is null or undefined`);
//                         continue;
//                     }

//                     // Get the actual canvas dimensions
//                     const canvasWidth = labelCanvas.width || labelConfig.canvasWidth || 600;
//                     const canvasHeight = labelCanvas.height || labelConfig.canvasHeight || 400;

//                     // Calculate scale to fit label dimensions (accounting for gaps)
//                     const actualLabelWidth = labelWidth - gapX;
//                     const actualLabelHeight = labelHeight - gapY;
//                     const scaleX = actualLabelWidth / canvasWidth;
//                     const scaleY = actualLabelHeight / canvasHeight;
//                     const scale = Math.min(scaleX, scaleY);

//                     console.log(`Sheet ${sheetIndex}, Canvas ${canvasIndex}: Original ${canvasWidth}x${canvasHeight}, Scale: ${scale}`);

//                     // Calculate vertical offset for this page
//                     const pageOffsetY = currentPageIndex * (singleSheetHeight + pageGap);

//                     // Add white background for this page/sheet
//                     const sheetBackground = new fabric.Rect({
//                         left: 0,
//                         top: pageOffsetY,
//                         width: labelConfig.sheetWidth,
//                         height: singleSheetHeight,
//                         fill: '#fff',
//                         selectable: false,
//                         evented: false
//                     });
//                     combinedCanvas.add(sheetBackground);

//                     // Calculate how many labels to render on this sheet
//                     const labelsOnPreviousSheets = sheetIndex * labelsPerSheet;
//                     const remainingLabels = totalQty - labelsOnPreviousSheets;
//                     const labelsOnThisSheet = Math.min(labelsPerSheet, remainingLabels);

//                     // Process each label position on the sheet
//                     for (let i = 0; i < labelsOnThisSheet; i++) {
//                         const row = Math.floor(i / cols);
//                         const col = i % cols;
//                         const offsetLeft = marginLeft + col * labelWidth;
//                         const offsetTop = marginTop + row * labelHeight + pageOffsetY;

//                         // Create a clipping rectangle for this label to prevent overflow
//                         const clipRect = new fabric.Rect({
//                             left: offsetLeft,
//                             top: offsetTop,
//                             width: actualLabelWidth,
//                             height: actualLabelHeight,
//                             absolutePositioned: true
//                         });

//                         // Get canvas background
//                         const canvasBg = labelCanvas.backgroundColor;
//                         if (canvasBg) {
//                             const bgRect = new fabric.Rect({
//                                 left: offsetLeft,
//                                 top: offsetTop,
//                                 width: actualLabelWidth,
//                                 height: actualLabelHeight,
//                                 fill: canvasBg,
//                                 selectable: false,
//                                 evented: false
//                             });
//                             combinedCanvas.add(bgRect);
//                         }

//                         // Handle background image with proper scaling
//                         const bgImage = labelCanvas.backgroundImage;
//                         if (bgImage) {
//                             await new Promise((resolve) => {
//                                 // Clone the background image
//                                 bgImage.clone((clonedBgImg) => {
//                                     if (!clonedBgImg) {
//                                         console.warn('Background image failed to clone');
//                                         resolve();
//                                         return;
//                                     }

//                                     // Scale and position background image
//                                     const bgScaleX = actualLabelWidth / clonedBgImg.width;
//                                     const bgScaleY = actualLabelHeight / clonedBgImg.height;
//                                     const bgScale = Math.max(bgScaleX, bgScaleY);

//                                     clonedBgImg.set({
//                                         left: offsetLeft,
//                                         top: offsetTop,
//                                         scaleX: bgScale,
//                                         scaleY: bgScale,
//                                         selectable: false,
//                                         evented: false,
//                                         clipPath: clipRect
//                                     });

//                                     clonedBgImg.setCoords();
//                                     combinedCanvas.add(clonedBgImg);
//                                     resolve();
//                                 }, ['selectable', 'evented']);
//                             });
//                         }

//                         // Handle all objects on the canvas with proper scaling
//                         const objects = labelCanvas.getObjects();
//                         if (objects && objects.length > 0) {
//                             for (const originalObj of objects) {
//                                 await new Promise((resolve) => {
//                                     try {
//                                         // Clone the object to avoid modifying the original
//                                         originalObj.clone((clonedObj) => {
//                                             if (!clonedObj) {
//                                                 resolve();
//                                                 return;
//                                             }

//                                             // Get original position and scale
//                                             const originalLeft = clonedObj.left || 0;
//                                             const originalTop = clonedObj.top || 0;
//                                             const originalScaleX = clonedObj.scaleX || 1;
//                                             const originalScaleY = clonedObj.scaleY || 1;

//                                             // Apply scale and position
//                                             clonedObj.set({
//                                                 left: offsetLeft + (originalLeft * scale),
//                                                 top: offsetTop + (originalTop * scale),
//                                                 scaleX: originalScaleX * scale,
//                                                 scaleY: originalScaleY * scale,
//                                                 selectable: false,
//                                                 evented: false,
//                                                 clipPath: clipRect
//                                             });

//                                             // Update coordinates for proper rendering
//                                             clonedObj.setCoords();

//                                             combinedCanvas.add(clonedObj);
//                                             resolve();
//                                         }, ['selectable', 'evented', 'left', 'top', 'scaleX', 'scaleY', 'angle', 'flipX', 'flipY', 'opacity', 'shadow', 'stroke', 'strokeWidth', 'fill']);
//                                     } catch (error) {
//                                         console.warn("Error cloning object:", error);
//                                         resolve();
//                                     }
//                                 });
//                             }
//                         }
//                     }

//                     currentPageIndex++;
//                 }
//             }

//             // Wait for all images to load and render
//             await new Promise(resolve => setTimeout(resolve, 800));

//             // Force final render
//             combinedCanvas.renderAll();

//             console.log("combinedCanvas", combinedCanvas);

//             const previewImage = combinedCanvas.toDataURL({
//                 format: "png",
//                 multiplier: 2
//             });

//             console.log("previewImage generated");

//             setImages([previewImage]);

//             // Clean up properly
//             combinedCanvas.dispose();
//         } catch (error) {
//             console.error("Error generating preview:", error);
//             alert(`Failed to generate preview: ${error.message}`);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const generateCMYKPDF = async () => {
//         if (images.length === 0) {
//             alert('No preview available. Please wait for the preview to generate.');
//             return;
//         }

//         setDownloadingPDF(true);

//         try {
//             const { jsPDF } = await import('jspdf');

//             const image = images[0];
//             const labelsPerSheet = labelConfig.rows * labelConfig.cols;
//             const totalSheets = Math.ceil(labelConfig.totalQty / labelsPerSheet);
//             const totalHeight = (labelConfig.sheetHeight * canvases.length * totalSheets) + (20 * (canvases.length * totalSheets - 1));
//             const widthInches = labelConfig.sheetWidth / 96;
//             const heightInches = totalHeight / 96;
//             const widthMM = widthInches * 25.4;
//             const heightMM = heightInches * 25.4;

//             const pdf = new jsPDF({
//                 orientation: widthMM > heightMM ? 'l' : 'p',
//                 unit: 'mm',
//                 format: [widthMM, heightMM],
//                 compress: true,
//                 precision: 2
//             });

//             pdf.addImage(
//                 image,
//                 'PNG',
//                 0,
//                 0,
//                 widthMM,
//                 heightMM,
//                 undefined,
//                 'FAST'
//             );

//             // Add print metadata
//             pdf.setProperties({
//                 title: 'Label Print',
//                 subject: 'Print Ready Labels',
//                 author: 'Label Maker',
//                 keywords: 'print, labels, business cards',
//                 creator: 'Label Maker Application'
//             });

//             // Generate filename with dimensions
//             const filename = `labels_${labelConfig.totalQty}qty_${Date.now()}.pdf`;
//             pdf.save(filename);

//             console.log(`PDF generated: ${filename}`);

//         } catch (error) {
//             console.error('Error generating PDF:', error);
//             alert('Failed to generate PDF. Please make sure jsPDF is installed: npm install jspdf');
//         } finally {
//             setDownloadingPDF(false);
//         }
//     };

//     return (
//         <div className="preview-container" style={{
//             width: '100%',
//             height: '100vh',
//             overflow: 'auto'
//         }}>
//             <div className="preview-body" style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 padding: '20px',
//                 backgroundColor: '#f5f5f5'
//             }}>
//                 {loading ? (
//                     <Spinner />
//                 ) : (
//                     images.map((src, i) => (
//                         <div key={i} className="preview-page" style={{
//                             maxWidth: '800px',
//                             width: '100%'
//                         }}>
//                             <img
//                                 src={src}
//                                 alt={`Combined Preview`}
//                                 style={{
//                                     width: '100%',
//                                     height: 'auto',
//                                     border: '1px solid #ddd',
//                                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                                     display: 'block'
//                                 }}
//                             />
//                         </div>
//                     ))
//                 )}
//             </div>

//             <button
//                 onClick={generateCMYKPDF}
//                 disabled={loading || downloadingPDF || images.length === 0}
//                 style={{
//                     padding: '10px 24px',
//                     backgroundColor: (loading || downloadingPDF || images.length === 0) ? '#ccc' : '#007bff',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: (loading || downloadingPDF || images.length === 0) ? 'not-allowed' : 'pointer',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px'
//                 }}
//             >
//                 {downloadingPDF ? (
//                     <>
//                         <Spinner size={16} />
//                         Generating PDF...
//                     </>
//                 ) : (
//                     'Download PDF'
//                 )}
//             </button>
//         </div>
//     );
// }

// ==================// AI CODE 0.1 ============================== //
// import axios from "axios";
// import { Spinner } from "@blueprintjs/core";
// import { useEffect, useState } from "react";
// import { fabric } from "fabric";
// import { APIURL } from "../../config";
// import { findObject } from "../../utils/helper";
// import "./preview.css";

// export function PreviewScreen({ canvases, templateID }) {
//     const [images, setImages] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [downloadingPDF, setDownloadingPDF] = useState(false);

//     const generatePreview = async () => {
//         setLoading(true);
//         setImages([]);

//         if (!canvases || canvases.length === 0) {
//             setLoading(false);
//             return;
//         }

//         try {
//             // 8.5" × 11" page size in pixels (96 DPI)
//             const DPI = 96;
//             const sheetWidthPx = 8.5 * DPI;   // 816px
//             const sheetHeightPx = 11 * DPI;   // 1056px

//             // 6 labels vertical layout (1 column × 6 rows)
//             const rows = 6;
//             const cols = 1;

//             // Margins and gaps
//             const margin = 0.5 * DPI;  // 0.5 inch margins
//             const gap = 0.125 * DPI;   // 0.125 inch gap between labels

//             // Calculate available space for 6 labels
//             const availableHeight = sheetHeightPx - (2 * margin) - ((rows - 1) * gap);
//             const labelHeightPx = availableHeight / rows;
//             const labelWidthPx = sheetWidthPx - (2 * margin);

//             console.log("Label dimensions:", {
//                 width: `${labelWidthPx}px (${(labelWidthPx/DPI).toFixed(2)}")`,
//                 height: `${labelHeightPx}px (${(labelHeightPx/DPI).toFixed(2)}")`
//             });

//             // Create canvas for the sheet
//             const canvas = new fabric.StaticCanvas(null, {
//                 width: sheetWidthPx,
//                 height: sheetHeightPx,
//                 backgroundColor: "#ffffff"
//             });

//             // Process the canvas (use first canvas only)
//             const labelCanvas = canvases[0];
//             if (labelCanvas) {
//                 // Get canvas dimensions
//                 const canvasWidth = labelCanvas.width || 600;
//                 const canvasHeight = labelCanvas.height || 400;

//                 // Calculate scale to fit within label space
//                 const scaleX = labelWidthPx / canvasWidth;
//                 const scaleY = labelHeightPx / canvasHeight;
//                 const scale = Math.min(scaleX, scaleY); // FIT without cropping

//                 // Calculate scaled dimensions
//                 const scaledWidth = canvasWidth * scale;
//                 const scaledHeight = canvasHeight * scale;

//                 // Center position within label space
//                 const centerX = (labelWidthPx - scaledWidth) / 2;
//                 const centerY = (labelHeightPx - scaledHeight) / 2;

//                 console.log("Scaling info:", {
//                     original: `${canvasWidth}x${canvasHeight}`,
//                     scaled: `${scaledWidth.toFixed(1)}x${scaledHeight.toFixed(1)}`,
//                     scale: scale.toFixed(3)
//                 });

//                 // Add 6 labels vertically
//                 for (let i = 0; i < 6; i++) {
//                     const top = margin + (i * (labelHeightPx + gap));
//                     const left = margin;

//                     // Add background if exists
//                     const canvasBg = labelCanvas.backgroundColor;
//                     if (canvasBg && canvasBg !== 'transparent') {
//                         const bgRect = new fabric.Rect({
//                             left: left + centerX,
//                             top: top + centerY,
//                             width: scaledWidth,
//                             height: scaledHeight,
//                             fill: canvasBg,
//                             selectable: false,
//                             evented: false
//                         });
//                         canvas.add(bgRect);
//                     }

//                     // Handle background image
//                     const bgImage = labelCanvas.backgroundImage;
//                     if (bgImage) {
//                         await new Promise((resolve) => {
//                             bgImage.clone((clonedBgImg) => {
//                                 if (clonedBgImg) {
//                                     clonedBgImg.set({
//                                         left: left + centerX,
//                                         top: top + centerY,
//                                         scaleX: scale,
//                                         scaleY: scale,
//                                         selectable: false,
//                                         evented: false
//                                     });
//                                     canvas.add(clonedBgImg);
//                                 }
//                                 resolve();
//                             });
//                         });
//                     }

//                     // Handle all objects
//                     const objects = labelCanvas.getObjects();
//                     if (objects && objects.length > 0) {
//                         for (const originalObj of objects) {
//                             await new Promise((resolve) => {
//                                 try {
//                                     originalObj.clone((clonedObj) => {
//                                         if (!clonedObj) {
//                                             resolve();
//                                             return;
//                                         }

//                                         const originalLeft = clonedObj.left || 0;
//                                         const originalTop = clonedObj.top || 0;
//                                         const originalScaleX = clonedObj.scaleX || 1;
//                                         const originalScaleY = clonedObj.scaleY || 1;

//                                         clonedObj.set({
//                                             left: left + centerX + (originalLeft * scale),
//                                             top: top + centerY + (originalTop * scale),
//                                             scaleX: originalScaleX * scale,
//                                             scaleY: originalScaleY * scale,
//                                             selectable: false,
//                                             evented: false
//                                         });

//                                         canvas.add(clonedObj);
//                                         resolve();
//                                     });
//                                 } catch (error) {
//                                     console.warn("Error cloning object:", error);
//                                     resolve();
//                                 }
//                             });
//                         }
//                     }
//                 }
//             }

//             // Render and get image
//             canvas.renderAll();

//             setTimeout(() => {
//                 const previewImage = canvas.toDataURL({
//                     format: "png",
//                     multiplier: 1
//                 });

//                 setImages([previewImage]);
//                 console.log("6 Labels Preview Generated");

//                 canvas.dispose();
//                 setLoading(false);
//             }, 300);

//         } catch (error) {
//             console.error("Error generating preview:", error);
//             setLoading(false);
//         }
//     };

//     const generatePDF = async () => {
//         if (images.length === 0) {
//             alert('Please generate preview first.');
//             return;
//         }

//         setDownloadingPDF(true);

//         try {
//             const { jsPDF } = await import('jspdf');

//             // Create 8.5" × 11" PDF
//             const pdf = new jsPDF({
//                 orientation: 'portrait',
//                 unit: 'in',
//                 format: [8.5, 11],
//                 compress: true
//             });

//             // Add image to cover entire page
//             pdf.addImage(
//                 images[0],
//                 'PNG',
//                 0,    // x position (inches)
//                 0,    // y position (inches)
//                 8.5,  // width (inches)
//                 11,   // height (inches)
//                 undefined,
//                 'FAST'
//             );

//             // Save PDF
//             const filename = `6_labels_8.5x11_${Date.now()}.pdf`;
//             pdf.save(filename);

//             console.log("PDF saved:", filename);

//         } catch (error) {
//             console.error('Error generating PDF:', error);
//             alert('Failed to generate PDF. Make sure jspdf is installed.');
//         } finally {
//             setDownloadingPDF(false);
//         }
//     };

//     return (
//         <div style={{
//             width: '100%',
//             minHeight: '100vh',
//             backgroundColor: '#f0f2f5'
//         }}>
//             <div style={{
//                 padding: '20px',
//                 textAlign: 'center',
//                 backgroundColor: '#ffffff',
//                 borderBottom: '1px solid #ddd'
//             }}>
//                 <h2 style={{ margin: 0, color: '#333' }}>6 Labels on 8.5" × 11"</h2>
//                 <p style={{ margin: '5px 0 0 0', color: '#666' }}>Vertical Layout - Perfect Fit</p>
//             </div>

//             <div style={{ padding: '20px' }}>
//                 {loading ? (
//                     <div style={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '300px'
//                     }}>
//                         <Spinner size={40} />
//                         <p style={{ marginTop: '10px', color: '#666' }}>Generating Preview...</p>
//                     </div>
//                 ) : images.length > 0 ? (
//                     <div style={{
//                         backgroundColor: '#fff',
//                         padding: '10px',
//                         borderRadius: '8px',
//                         boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                         maxWidth: '800px',
//                         margin: '0 auto'
//                     }}>
//                         <img
//                             src={images[0]}
//                             alt="Preview"
//                             style={{
//                                 width: '100%',
//                                 height: 'auto',
//                                 border: '1px solid #eee',
//                                 borderRadius: '4px'
//                             }}
//                         />
//                     </div>
//                 ) : (
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '40px',
//                         color: '#666'
//                     }}>
//                         No preview generated yet
//                     </div>
//                 )}
//             </div>

//             <div style={{
//                 position: 'sticky',
//                 bottom: 0,
//                 padding: '15px',
//                 backgroundColor: '#fff',
//                 borderTop: '1px solid #ddd',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: '10px'
//             }}>
//                 <button
//                     onClick={generatePreview}
//                     disabled={loading}
//                     style={{
//                         padding: '10px 20px',
//                         backgroundColor: loading ? '#ccc' : '#28a745',
//                         color: '#fff',
//                         border: 'none',
//                         borderRadius: '4px',
//                         cursor: loading ? 'not-allowed' : 'pointer',
//                         fontSize: '14px'
//                     }}
//                 >
//                     {loading ? 'Generating...' : 'Generate Preview'}
//                 </button>

//                 <button
//                     onClick={generatePDF}
//                     disabled={loading || downloadingPDF || images.length === 0}
//                     style={{
//                         padding: '10px 20px',
//                         backgroundColor: (loading || downloadingPDF || images.length === 0) ? '#ccc' : '#007bff',
//                         color: '#fff',
//                         border: 'none',
//                         borderRadius: '4px',
//                         cursor: (loading || downloadingPDF || images.length === 0) ? 'not-allowed' : 'pointer',
//                         fontSize: '14px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '5px'
//                     }}
//                 >
//                     {downloadingPDF ? (
//                         <>
//                             <Spinner size={14} />
//                             Creating PDF...
//                         </>
//                     ) : (
//                         'Download PDF'
//                     )}
//                 </button>
//             </div>
//         </div>
//     );
// }







import axios from "axios";
import { Spinner } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { fabric } from "fabric";
import { APIURL } from "../../config";
import { findObject, getUniqueValues } from "../../utils/helper";
import "./preview.css";

export function PreviewScreen({ canvases, templateID, previewOpen, images, setImages, TemplateData, setTemplateData, CategoriesData, setCategoriesData, canvasesOriganl }) {
    // const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [labelConfig, setLabelConfig] = useState({
        sheetWidth: 8.5, //  816 px
        sheetHeight: 11, // 1056 px
        rows: 1,
        cols: 1,
        gapX: 0,
        gapY: 0,
        marginLeft: 0,
        marginTop: 0,
        totalQty: 1
    });
    const [configLoaded, setConfigLoaded] = useState(false);
    const [downloadingPDF, setDownloadingPDF] = useState(false);

    const calculateAndSetConfig = (templateData, categoryObj) => {
        if ((!templateData.rows || !templateData.cols)) {
            templateData.sheetWidth = labelConfig.sheetWidth;
            templateData.sheetHeight = labelConfig.sheetHeight;
            templateData.rows = labelConfig.rows;
            templateData.cols = labelConfig.cols;
            templateData.gapX = labelConfig.gapX;
            templateData.gapY = labelConfig.gapY;
            templateData.marginLeft = labelConfig.marginLeft;
            templateData.marginTop = labelConfig.marginTop;
        }
        // Standard 8.5 x 11 inches at 96 DPI
        // console.log('templateData.sheetHeight', templateData)
        if ((categoryObj.enable_labels == 0)) {
            templateData.sheetWidth = parseFloat(categoryObj.canvas_width_in)
            templateData.sheetHeight = parseFloat(categoryObj.canvas_height_in)
        }
        // console.log('templateData.sheetWidth', templateData.sheetWidth)
        // console.log('templateData.sheetHeight', templateData.sheetHeight)

        const SHEET_WIDTH_PX = templateData.sheetWidth * 96;  // 816px
        const SHEET_HEIGHT_PX = templateData.sheetHeight * 96;   // 1056px

        setTemplateData(templateData)
        setCategoriesData(categoryObj)

        const rows = categoryObj.enable_labels == 0 ? Number(1) : Number(templateData.rows);
        const cols = categoryObj.enable_labels == 0 ? Number(1) : Number(templateData.cols);
        const gapX = categoryObj.enable_labels == 0 ? Number(0) : Number(templateData.gapX);
        const gapY = categoryObj.enable_labels == 0 ? Number(0) : Number(templateData.gapY);
        const marginLeft = categoryObj.enable_labels == 0 ? Number(0) : Number(templateData.marginLeft);
        const marginTop = categoryObj.enable_labels == 0 ? Number(0) : Number(templateData.marginTop);
        const totalQty = categoryObj.enable_labels == 0 ? Number(1) : (Number(templateData.totalQty) || 1);

        let availableWidth, availableHeight, labelWidth, labelHeight, actualLabelWidth, actualLabelHeight;

        // Special handling for single column layout (full width labels)
        if (cols === 1) {
            // For single column, use full width with margins
            availableWidth = SHEET_WIDTH_PX - (marginLeft * 2);
            availableHeight = SHEET_HEIGHT_PX - (marginTop * 2);

            // Full width minus gaps
            actualLabelWidth = availableWidth - gapX;

            // Height divided by rows with gaps
            labelHeight = availableHeight / rows;
            actualLabelHeight = labelHeight - gapY;

            labelWidth = availableWidth;
        } else {
            // Standard multi-column calculation
            availableWidth = SHEET_WIDTH_PX - (marginLeft * 2);
            availableHeight = SHEET_HEIGHT_PX - (marginTop * 2);

            labelWidth = availableWidth / cols;
            labelHeight = availableHeight / rows;

            actualLabelWidth = labelWidth - gapX;
            actualLabelHeight = labelHeight - gapY;
        }

        const newConfig = {
            sheetWidth: SHEET_WIDTH_PX,
            sheetHeight: SHEET_HEIGHT_PX,
            rows,
            cols,
            labelWidth,
            labelHeight,
            actualLabelWidth,
            actualLabelHeight,
            gapX,
            gapY,
            marginLeft,
            marginTop,
            canvasWidth: categoryObj.canvas_width_px,
            canvasHeight: categoryObj.canvas_height_px,
            totalQty
        };

        setLabelConfig(newConfig);
        console.log("labelConfig loaded:", newConfig);
        setConfigLoaded(true);
    };

    // Fetch template configuration when templateID is provided
    useEffect(() => {
        if (!templateID) return;
        setConfigLoaded(false);
        axios.get(`${APIURL}/api/v1/template`, { params: { template_id: templateID } }).then((response) => {
            if (response.data.data.length > 0) {
                const get_category = `${APIURL}/api/v1/category`;
                let catSlugValue = response.data.data[0].cat_slug;
                axios.post(get_category, { cat_slug: catSlugValue }).then(function (categoryResponse) {
                    let result = findObject(categoryResponse.data.data, (obj) => obj.template_id === parseInt(templateID, 10));
                    calculateAndSetConfig(response.data.data[0], result);
                }).catch(function (error) {
                    console.log(error);
                });
            }
        }).catch((error) => {
            console.error("Error fetching template:", error);
        });
    }, [templateID]);

    // Fetch default template when no templateID is provided
    useEffect(() => {
        if (templateID) return;

        setConfigLoaded(false);
        const fetchDefaultTemplate = async () => {
            try {
                const categoriesRes = await axios.get(`${APIURL}/api/v1/categories`);

                if (categoriesRes.data.data.length === 0) {
                    console.log("No categories found");
                    return;
                }

                const categoryRes = await axios.post(`${APIURL}/api/v1/category`, {
                    cat_slug: categoriesRes.data.data[0].cat_slug
                });

                if (categoryRes.data.data.length === 0) {
                    console.log("No category detail found");
                    return;
                }

                const categoryDetail = categoryRes.data.data[0];

                const templateRes = await axios.get(`${APIURL}/api/v1/template`, {
                    params: { template_id: categoryDetail.template_id }
                });

                if (templateRes.data.data.length > 0) {
                    let result = findObject(categoryRes.data.data, (obj) => obj.template_id === parseInt(categoryDetail.template_id, 10));
                    calculateAndSetConfig(templateRes.data.data[0], result);
                }
            } catch (error) {
                console.error("Error fetching default template:", error);
            }
        };

        fetchDefaultTemplate();
    }, [templateID]);

    useEffect(() => {
        if (
            configLoaded &&
            canvases?.length &&
            labelConfig.rows > 0 &&
            labelConfig.cols > 0 &&
            labelConfig.labelWidth > 0 &&
            labelConfig.labelHeight > 0
        ) {
            generatePreview();
        }
    }, [labelConfig, canvases, configLoaded]);

    const generatePreview = async () => {
        setLoading(true);

        if (!canvases || canvases.length === 0) {
            setLoading(false);
            return;
        }

        try {
            const { rows, cols, labelWidth, labelHeight, actualLabelWidth, actualLabelHeight, gapX, gapY, marginLeft, marginTop, totalQty, sheetWidth, sheetHeight } = labelConfig;

            // Calculate sheets needed
            const labelsPerSheet = rows * cols;
            const totalSheets = Math.ceil(totalQty / labelsPerSheet);

            // Store all sheet images
            const allSheetImages = [];

            // Generate each sheet separately
            for (let sheetIndex = 0; sheetIndex < totalSheets; sheetIndex++) {
                // For each canvas (Front, Back, etc.)
                for (let canvasIndex = 0; canvasIndex < canvases.length; canvasIndex++) {
                    let labelCanvas = canvases[canvasIndex];
                    let labelCanvasOriganl = canvasesOriganl[canvasIndex];
                    labelCanvas.setZoom(labelCanvasOriganl.getZoom());
                    labelCanvas.setHeight(labelCanvasOriganl.getHeight());
                    labelCanvas.setWidth(labelCanvasOriganl.getWidth());
                    if (!labelCanvas) {
                        console.warn(`Canvas at index ${canvasIndex} is null or undefined`);
                        continue;
                    }

                    // Create a new canvas for this sheet (8.5" x 11")
                    const sheetCanvas = new fabric.StaticCanvas(null, {
                        width: sheetWidth,
                        height: sheetHeight,
                        backgroundColor: "#ffffff"
                    });

                    // Get canvas dimensions
                    console.log('labelCanvas----width', labelCanvas.width)
                    console.log('labelCanvas----height', labelCanvas.height)
                    console.log('labelConfig----canvasWidth', labelConfig.canvasWidth)
                    console.log('labelConfig----canvasHeight', labelConfig.canvasHeight)
                    const canvasWidth = labelCanvas.width || labelConfig.canvasWidth || 600;
                    const canvasHeight = labelCanvas.height || labelConfig.canvasHeight || 400;

                    // Calculate scale to fit label area
                    const scaleX = actualLabelWidth / canvasWidth;
                    const scaleY = actualLabelHeight / canvasHeight;
                    const scale = Math.min(scaleX, scaleY);

                    console.log(`Sheet ${sheetIndex}, Canvas ${canvasIndex}: Scale ${scale}, Label: ${actualLabelWidth}x${actualLabelHeight}`);

                    // Calculate labels for this sheet
                    const labelsOnPreviousSheets = sheetIndex * labelsPerSheet;
                    const remainingLabels = totalQty - labelsOnPreviousSheets;
                    const labelsOnThisSheet = Math.min(labelsPerSheet, remainingLabels);

                    // Render each label position
                    for (let i = 0; i < labelsOnThisSheet; i++) {
                        const row = Math.floor(i / cols);
                        const col = i % cols;

                        // Position calculation
                        let offsetLeft, offsetTop;

                        if (cols === 1) {
                            // Single column: center horizontally, stack vertically
                            offsetLeft = marginLeft + (gapX / 2);
                            offsetTop = marginTop + (row * labelHeight) + (gapY / 2);
                        } else {
                            // Multi column: standard grid
                            offsetLeft = marginLeft + (col * labelWidth) + (gapX / 2);
                            offsetTop = marginTop + (row * labelHeight) + (gapY / 2);
                        }

                        // Create clipping rectangle
                        // const clipRect = new fabric.Rect({
                        //     left: offsetLeft,
                        //     top: offsetTop,
                        //     width: actualLabelWidth,
                        //     height: actualLabelHeight,
                        //     absolutePositioned: true
                        // });

                        // Add background color
                        const canvasBg = labelCanvas.backgroundColor;
                        if (canvasBg) {
                            const bgRect = new fabric.Rect({
                                left: offsetLeft,
                                top: offsetTop,
                                width: actualLabelWidth,
                                height: actualLabelHeight,
                                fill: canvasBg,
                                selectable: false,
                                evented: false
                            });
                            sheetCanvas.add(bgRect);
                        }

                        // Add background image
                        const bgImage = labelCanvas.backgroundImage;
                        if (bgImage) {
                            await new Promise((resolve) => {
                                bgImage.clone((clonedBgImg) => {
                                    if (!clonedBgImg) {
                                        resolve();
                                        return;
                                    }

                                    const bgScaleX = actualLabelWidth / clonedBgImg.width;
                                    const bgScaleY = actualLabelHeight / clonedBgImg.height;
                                    const bgScale = Math.max(bgScaleX, bgScaleY);

                                    clonedBgImg.set({
                                        left: offsetLeft,
                                        top: offsetTop,
                                        scaleX: bgScale,
                                        scaleY: bgScale,
                                        selectable: false,
                                        evented: false,
                                        // clipPath: clipRect
                                    });

                                    clonedBgImg.setCoords();
                                    sheetCanvas.add(clonedBgImg);
                                    resolve();
                                }, ['selectable', 'evented']);
                            });
                        }

                        // Add all canvas objects
                        const objects = labelCanvas.getObjects();
                        if (objects && objects.length > 0) {
                            for (const originalObj of objects) {
                                if (TemplateData.pdf_cut_margin == 1) {
                                    if (originalObj.name === "cut-margin" || originalObj.name === "safe-margin") {
                                        continue;
                                    }
                                }

                                await new Promise((resolve) => {
                                    try {
                                        originalObj.clone((clonedObj) => {
                                            if (!clonedObj) {
                                                resolve();
                                                return;
                                            }

                                            const originalLeft = clonedObj.left || 0;
                                            const originalTop = clonedObj.top || 0;
                                            const originalScaleX = clonedObj.scaleX || 1;
                                            const originalScaleY = clonedObj.scaleY || 1;

                                            clonedObj.set({
                                                left: offsetLeft + (originalLeft * scale),
                                                top: offsetTop + (originalTop * scale),
                                                scaleX: originalScaleX * scale,
                                                scaleY: originalScaleY * scale,
                                                selectable: false,
                                                evented: false,
                                                // clipPath: clipRect
                                            });

                                            clonedObj.setCoords();
                                            sheetCanvas.add(clonedObj);
                                            resolve();
                                        }, ['selectable', 'evented', 'left', 'top', 'scaleX', 'scaleY', 'angle', 'flipX', 'flipY', 'opacity', 'shadow', 'stroke', 'strokeWidth', 'fill']);
                                    } catch (error) {
                                        console.warn("Error cloning object:", error);
                                        resolve();
                                    }
                                });
                            }
                        }
                    }

                    // Render and save this sheet
                    await new Promise(resolve => setTimeout(resolve, 100));
                    sheetCanvas.renderAll();

                    const sheetImage = sheetCanvas.toDataURL({
                        format: "png",
                        multiplier: 2
                    });

                    allSheetImages.push(sheetImage);
                    sheetCanvas.dispose();
                }
            }

            console.log(`Generated ${allSheetImages.length} sheet images`);
            setImages(allSheetImages);

        } catch (error) {
            console.error("Error generating preview:", error);
            alert(`Failed to generate preview: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const generateCMYKPDF = async () => {
        if (images.length === 0) {
            alert('No preview available. Please wait for the preview to generate.');
            return;
        }

        setDownloadingPDF(true);

        try {
            const { jsPDF } = await import('jspdf');

            // Standard 8.5 x 11 inches in mm
            const widthInches = 8.5;
            const heightInches = 11;
            const widthMM = widthInches * 25.4; // 215.9mm
            const heightMM = heightInches * 25.4; // 279.4mm

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [widthMM, heightMM],
                compress: true,
                precision: 2
            });

            // Add each sheet as a separate page
            for (let i = 0; i < images.length; i++) {
                if (i > 0) {
                    pdf.addPage([widthMM, heightMM], 'portrait');
                }

                pdf.addImage(
                    images[i],
                    'PNG',
                    0,
                    0,
                    widthMM,
                    heightMM,
                    undefined,
                    'FAST'
                );
            }

            // Add print metadata
            pdf.setProperties({
                title: 'Label Print',
                subject: 'Print Ready Labels',
                author: 'Label Maker',
                keywords: 'print, labels, business cards',
                creator: 'Label Maker Application'
            });

            const labelsPerSheet = labelConfig.rows * labelConfig.cols;
            const totalSheets = Math.ceil(labelConfig.totalQty / labelsPerSheet);
            const filename = `labels_${labelConfig.totalQty}qty_${totalSheets}sheets_${Date.now()}.pdf`;
            pdf.save(filename);

            console.log(`PDF generated: ${filename} with ${images.length} pages`);

        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Failed to generate PDF: ' + error.message);
        } finally {
            setDownloadingPDF(false);
        }
    };

    const sendImageAndPDFToAPI = async () => {
        if (images.length === 0) {
            alert('No preview available. Please generate preview first.');
            return;
        }

        setSendingToAPI(true);

        try {
            const { jsPDF } = await import('jspdf');
            const widthMM = 8.5 * 25.4;
            const heightMM = 11 * 25.4;
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [widthMM, heightMM],
                compress: true,
            });

            for (let i = 0; i < images.length; i++) {
                if (i > 0) pdf.addPage();
                pdf.addImage(images[i], 'PNG', 0, 0, widthMM, heightMM);
            }

            const pdfBase64 = pdf.output('dataurlstring');
            const imageBase64 = images[0];

            const imageFile = base64ToFile(imageBase64, 'preview.png');
            const pdfFile = base64ToFile(pdfBase64, 'document.pdf');

            const api_url = apiUrl ? atob(atob(apiUrl)) : null;
            const encodedData = JSON.stringify({
                session_id: sessionId,
                cart_key: cartKey,
            });

            const formData = new FormData();
            formData.append('token', btoa(encodedData));
            formData.append('image', imageFile);
            formData.append('pdf', pdfFile);
            formData.append('wordpress_api_url', api_url ? api_url : 'https://dev.colorflex.com/wp-json/pt/v1/preview');
            const response = await axios.post(`${APIURL}/api/v1/save-image-pdf`, formData);

            console.log("response.data", response.data);

            if (response.data.wordpress_response && response.data.wordpress_response.data && response.data.wordpress_response.data.message) {
                setRedirection(response.data.wordpress_response.data.cart_url);
                setIsOpen(true);
            } else {
                const toaster = OverlayToaster.create({
                    position: Position.TOP_RIGHT,
                    maxToasts: 1,
                    autoFocus: false,
                    canEscapeKeyClear: true,
                });

                toaster.show({
                    message: response.data.wordpress_response?.data?.error || 'An error occurred',
                    intent: Intent.DANGER,
                    icon: "error",
                    timeout: 3000,
                });
            }

        } catch (error) {
            console.error('Error sending to API:', error);

            const toaster = OverlayToaster.create({
                position: Position.TOP_RIGHT,
                maxToasts: 1,
                autoFocus: false,
                canEscapeKeyClear: true,
            });

            toaster.show({
                message: "Oops! Something went wrong during save.",
                intent: Intent.DANGER,
                icon: "error",
                timeout: 3000,
            });
        } finally {
            setSendingToAPI(false);
        }
    };

    const base64ToFile = (base64, filename) => {
        const arr = base64.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };

    return (
        <div className="preview-container" style={{
            width: '100%',
            height: '100vh',
            overflow: 'auto'
        }}>
            {/* <div className="preview-header">
                <button
                    onClick={generateCMYKPDF}
                    disabled={loading || downloadingPDF || images.length === 0}
                    style={{
                        padding: '10px 24px',
                        backgroundColor: (loading || downloadingPDF || images.length === 0) ? '#ccc' : '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: (loading || downloadingPDF || images.length === 0) ? 'not-allowed' : 'pointer',
                        fontSize: '14px',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}
                >
                    {downloadingPDF ? (
                        <>
                            <Spinner size={16} />
                            Generating PDF...
                        </>
                    ) : (
                        `Download PDF (${images.length} pages)`
                    )}
                </button>
            </div> */}

            <div className="preview-body" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
                padding: '20px',
                backgroundColor: '#f5f5f5'
            }}>
                {loading ? (
                    <Spinner />
                ) : (
                    images.map((src, i) => (
                        <div key={i} className="preview-page" style={{
                            maxWidth: '800px',
                            width: '100%',
                            position: 'relative'
                        }}>
                            {/* <div style={{
                                fontSize: '12px',
                                color: '#666',
                                marginBottom: '8px',
                                textAlign: 'center'
                            }}>
                                Page {i + 1} of {images.length}
                            </div> */}
                            <img
                                src={src}
                                alt={`Sheet ${i + 1}`}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    border: '1px solid #ddd',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    display: 'block',
                                    backgroundColor: '#fff'
                                }}
                            />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}